import { render, staticRenderFns } from "./BottomDialog.vue?vue&type=template&id=5b2875d5&lang=pug&"
import script from "./BottomDialog.vue?vue&type=script&lang=js&"
export * from "./BottomDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BottomDialog.vue"
export default component.exports